import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Webpack's runtime public path: '/' for the web build, '/hosts/atlas/' for the
// embedded build (publicPath 'auto', resolved from the entry script's URL).
declare const __webpack_public_path__: string;

/**
 * Resolve a file that lives in `public/` (copied verbatim into the build) to a
 * URL that works in BOTH the web build (served at '/') and the embedded build
 * (served under '/hosts/atlas/'). A hardcoded absolute path like
 * `/atlas-logo.png` ignores the embed's `<base href>` and 404s against the
 * shell root, so route public assets through here instead.
 */
export function publicAsset(name: string): string {
  const base = typeof __webpack_public_path__ !== 'undefined' ? __webpack_public_path__ : '/';
  return `${base}${name.replace(/^\/+/, '')}`;
}
